import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { PLATFORMS } from "shared/types/enums";

const WarningMessage = () => {
    const { t } = useTranslation();

    return (
        <BannerView
            bannerType={BannerType.Info}
            title={t("Dialog##platform compatibility##banner text")}
            css={css({
                margin: "4px 0 16px 0"
            })}
        />
    );
};

export default WarningMessage;
export { PLATFORMS };
